import $ from "jquery";
import Marionette from "backbone.marionette";

import modelUtil from "js/models/util";
import tmpl from "js/templates/steps";
import { calculateDurationString, isLikelyContractJob } from "lib/util";

const HistoryItemView = Marionette.View.extend({
    render() {
        this.bindUIElements();

        this.$el.html(this.template({ data: this.serializeData() }));

        this.$el = this.$el.children();
        this.$el.unwrap();
        this.setElement(this.$el);

        const self = this;
        this.$el.find(".job-content, .edit-row").click((event) => {
            if ($(event.target).closest(".js-no-edit, .job-content--disabled").length) {
                return;
            }

            event.preventDefault();

            self.model.trigger("edit", self.model);
        });

        this.listenTo(this.model, "rerender", this.render);
    },
});

const GapItemView = HistoryItemView.extend({
    template: tmpl.GapRow,
    events: {
        "click .js-ignore": "onIgnore",
        "click .js-add-job": "onAddJob",
        "click .js-explain": "onStartExplain",
        "click .js-explain-finish": "onFinishExplain",
        "click .js-delete": "onDeleteGap",
    },
    ui: {
        reason: "textarea",
    },
    initialize() {
        this.listenTo(this.model, "edit", this.onStartExplain);
    },
    serializeData() {
        const data = this.model.toJSON();
        data.dates = this.model.getDates();
        data.editing = !!this.editing;

        return data;
    },
    onIgnore(event) {
        event.preventDefault();

        this.updateGap(null, true);
        this.render();
    },
    onDeleteGap(event) {
        event.preventDefault();
        this.editing = false;

        this.updateGap(null, false);
        this.render();
    },
    onAddJob(event) {
        event.preventDefault();

        this.model.trigger("add-job", this.model);
    },
    onStartExplain() {
        this.editing = true;
        this.render();

        if (this.ui.reason.length) {
            this.ui.reason[0].focus();
        }
    },
    onFinishExplain(event) {
        event.preventDefault();

        const reason = this.ui.reason.val().trim();
        if (!reason) {
            this.ui.reason.addClass("validation-error").val("");
            this.ui.reason[0].focus();
            return;
        }

        this.editing = false;
        this.updateGap(reason, false);
        this.render();
    },
    updateGap(reason, ignore) {
        const origReason = this.model.get("reason");
        const origIgnore = this.model.get("ignore") || false;

        if (reason === null) {
            this.model.unset("reason");
        } else {
            this.model.set("reason", reason || "");
        }

        if (ignore && !reason) {
            this.model.set("ignore", true);
        } else {
            this.model.unset("ignore");
        }

        if (reason !== origReason || ignore !== origIgnore) {
            this.model.trigger("save");
        }
    },
});

const JobItemView = HistoryItemView.extend({
    template: tmpl.JobRow,
    serializeData() {
        const data = this.model.toJSON();
        data.dates = this.model.getDates();
        data.durationString = calculateDurationString(data.start_date, data.end_date);

        let contractJob = isLikelyContractJob(data);
        if (Object.prototype.hasOwnProperty.call(data, "contract_job")) {
            contractJob = data.contract_job;
        }

        if (data.reason_for_leaving) {
            data.reason_for_leaving = modelUtil.formatConstant(
                modelUtil.REASON_FOR_LEAVING_LOOKUP[Number(data.reason_for_leaving)],
            );
        }

        data.displayAsContractJob = contractJob;
        data.miniCard = !!this.options.miniCard;

        return data;
    },
});

export { GapItemView, JobItemView };
